"use client";

import { Globe, ExternalLink } from "lucide-react";
import { safeHostname } from "../../../utils";

export interface URLPreviewProps {
  sourceUrl: string;
  citedText: string;
}

export function URLPreview({ sourceUrl, citedText }: URLPreviewProps) {
  const hostname = safeHostname(sourceUrl);
  return (
    <div className="p-3 space-y-2">
      <div className="flex items-center gap-2 text-xs text-blue-600 dark:text-blue-400 font-medium">
        <Globe className="h-3.5 w-3.5 flex-shrink-0" />
        <span className="truncate">{hostname}</span>
      </div>
      {/* quovy-lint-ignore prefer-notice -- quoted-citation excerpt box, not a status message */}
      <div className="bg-blue-50 dark:bg-blue-950/30 rounded-md p-2 border border-blue-100 dark:border-blue-900">
        <p className="text-sm text-stone-600 dark:text-stone-300 leading-relaxed line-clamp-4">
          {citedText}
        </p>
      </div>
      <a
        href={sourceUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-1 text-xs text-blue-600 dark:text-blue-400 hover:underline"
      >
        <ExternalLink className="h-3 w-3" />
        Open source
      </a>
    </div>
  );
}
